import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LoadingContainer, TopImage } from '@project/components';

import { useGetAllCharityOutreachesQuery } from '@project/queries';

export const CharityOutReach: React.FC = () => {
  const { data: charityOutreaches, isLoading } = useGetAllCharityOutreachesQuery();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const CharityBlocks = ({ src, title, id }: { src: string; title: string; id: string }) => {
    const navigate = useNavigate();

    const handleBlockClick = () => {
      navigate(`/individual-country-charities/${id}`);
    };

    return (
      <div className="flex cursor-pointer flex-col p-4 sm:p-10" onClick={handleBlockClick}>
        <div>
          <img className="w-[500px]" src={src} />
        </div>
        <div>
          <p
            className={`z-10 bg-white p-1 text-center font-semibold text-black shadow-sm shadow-gray-400`}
          >
            {title}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="mb-32 flex flex-col">
      <TopImage />
      <div className="my-12 ml-4 md:ml-36">
        <p className="mb-2 text-3xl font-semibold tracking-wide">Charity Outreach</p>
        <div className="w-24 rounded border-2 border-gold" />
      </div>
      <LoadingContainer isLoading={isLoading}>
        <div className="mx-auto grid lg:grid-cols-3">
          {charityOutreaches?.map((charity) => (
            <CharityBlocks
              id={String(charity.id)}
              key={charity.id}
              src={charity.featureImage}
              title={`${charity.name} Outreach`}
            />
          ))}
        </div>
      </LoadingContainer>
    </div>
  );
};
